import { MY_CLUB_EDIT_PAGE, getCourtPageUrl } from 'constants/pages';
import Pencil from 'svg/Pencil';
import { ButtonLink } from 'components/Button';

interface Props {
  /** Public venue slug, used to build the "View as client" link. */
  slug?: string;
}

export default function OverviewHeader({ slug }: Props) {
  return (
    <header className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <h1 className="typography-product-heading-desktop text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
        Club profile
      </h1>

      <div className="flex items-center gap-3">
        {slug && (
          <ButtonLink href={getCourtPageUrl(slug)} variant="primary" size="md" isInline>
            View as player
          </ButtonLink>
        )}
        <ButtonLink
          href={MY_CLUB_EDIT_PAGE}
          variant="secondary"
          size="md"
          isInline
          iconLeft={<Pencil className="h-4 w-4" />}
        >
          Edit profile
        </ButtonLink>
      </div>
    </header>
  );
}
